import { FormattedMessage } from 'react-intl';

import { AddToSlackButton } from '@/components/global/InstallSlack';

export const InstallSlackApp = (): JSX.Element => {
  return (
    <section>
      <h1 className="text-xl mb-2">
        <FormattedMessage id="configuration.slackApp.title" />
      </h1>
      <AddToSlackButton variant="main" />
    </section>
  );
};
